export default __webpack_public_path__ + "static/2018-7897dd9f87bbf068b9d04405ef79575e.jpg";